import Layout from '@/layout'

export const routerList = [
  {
    path: '/hr',
    component: Layout,
    meta: {
      title: '人事',
      icon: 'icon-chanpinPIguanli-01'
    },
    alwaysShow: true,
    children: [
      {
        path: '/hr/trans',
        component: () => import('@/views/Contract/Index'),
        name: 'HrTrans',
        meta: { title: '人员调度', affix: false }
      },
      {
        path: '/hr/detail/:id',
        component: () => import('@/views/Contract/Detail'),
        name: 'HrDetail',
        hidden: true,
        meta: { title: '合同详情', affix: false }
      }
    ]
  }
]
